import { SOFT_DELETE_PREDICATE } from "#soft-delete-predicate";

// Merges the user's `where` config with the soft-delete predicate. The
// relational query API uses an `AND` array for conjunction, so we wrap both
// clauses in one when both exist; otherwise we just hand back the single
// predicate to avoid noise in the generated SQL.
export function mergeSoftDeleteWhere(config: { where?: unknown } | undefined): {
  where?: unknown;
} {
  if (config?.where === undefined || config.where === null) {
    return { ...config, where: SOFT_DELETE_PREDICATE };
  }
  return { ...config, where: { AND: [config.where, SOFT_DELETE_PREDICATE] } };
}
